import {Type} from 'class-transformer'
import {AlertCircle} from 'react-feather'

import {Sku} from './Sku'

export class OverageSummary {
  static type = 'overagesummary'
  static typeDisplay = 'Overage Summary'
  static icon = AlertCircle

  type = OverageSummary.type
  typeDisplay = OverageSummary.typeDisplay
  icon = OverageSummary.icon

  guid: string = ''

  overage: number = 0

  @Type(() => Sku)
  sku?: Sku
}
